import {I18n} from '@aws-amplify/core';
import {BindingDriftReport} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardEntryInput,
} from "@flexinet/ui-components";
import {Stack} from "@mantine/core";
import {RunHealthBadge} from "./Badges.tsx";

// The run summary and its outcome counts — the left panel of the detail page.
//
// ⚠️ Typed PlatformPropertyCardEntryInput[], never cast (FNP-1882). The arrays used
// to end in `as PlatformPropertyCardProperty[]`, which switched off the excess-
// property check: `formatAs: 'Timestamp'` compiled clean, the card ignored it, and
// both run timestamps rendered as raw ISO strings. Typed, a wrong key is a tsc error.
export const Profile = ({record}: { record: BindingDriftReport }) => {

    const summaryProperties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('ID'),
            value: record.id,
            formatter: 'code',
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: I18n.get('Status'),
            value: <RunHealthBadge record={record}/>,
            span: 12,
        },
        {
            label: I18n.get('Run Date'),
            value: record.runDate,
            emptyAs: 'dash',
            span: 6,
        },
        {
            label: I18n.get('Accounts Scanned'),
            value: record.accountsScanned,
            emptyAs: 'dash',
            span: 6,
        },
        {
            label: I18n.get('Run Started At'),
            value: record.runStartedAt,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 6,
        },
        {
            // Null while a run is in flight or if it died before completing.
            label: I18n.get('Run Completed At'),
            value: record.runCompletedAt,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 6,
        },
    ];

    const outcomeProperties: PlatformPropertyCardEntryInput[] = [
        {label: I18n.get('Drift Detected'), value: record.driftDetectedCount ?? 0, span: 6},
        {label: I18n.get('Repaired'), value: record.repairedCount ?? 0, span: 6},
        {label: I18n.get('Repair Failed'), value: record.repairFailedCount ?? 0, span: 6},
        {label: I18n.get('Repair Capped'), value: record.repairCappedCount ?? 0, span: 6},
    ];

    return (
        <Stack gap={'lg'}>
            <PlatformPropertyCard properties={summaryProperties}/>
            <PlatformPropertyCard properties={outcomeProperties}/>
        </Stack>
    );
};
